<template lang="pug">
.wrap
  page-title Location detail

  location-form(:key='locationId' v-if='location' v-model='location' :create='false' @save='onSave' @delete='confirmDelete')
</template>

<script>
import { mapActions } from "vuex";
import PageTitle from "@/shared/components/layout/PageTitle";
import CrudMixin from "@/shared/mixins/Crud";
import LocationForm from "@/brapp/components/shared/locations/LocationForm";

export default {
  mixins: [CrudMixin],
  components: { PageTitle, LocationForm },
  data() {
    return {
      location: null
    };
  },
  created() {
    this.loadData();
  },
  computed: {
    locationId() {
      return this.$route.params.locationId;
    }
  },
  methods: {
    ...mapActions("products", [
      "fetchLocation",
      "updateLocation",
      "deleteLocation"
    ]),
    loadData() {
      this.wrapLoadAction(this.fetchLocation)({ id: this.locationId }).then(
        data => {
          this.location = data;
        }
      );
    },
    onSave({ valid }) {
      if (!valid) {
        this.$notify({
          title: "Error",
          message: "Please fix the validation errors",
          type: "error"
        });
        return;
      }

      this.wrapApiAction(this.updateLocation)({
        data: { ...this.location }
      }).then(data => {
        this.location = data;
      });
    },
    confirmDelete() {
      this.$confirm(
        "This will permanently delete this location. Continue?",
        "Warning",
        {
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          type: "warning"
        }
      ).then(() => {
        this.deleteLocation({ id: this.location.id }).then(() => {
          this.$message({
            type: "info",
            message: "Location deleted"
          });
          this.$router.push({ name: "brapp:sales:locationList" });
        });
      });
    }
  }
};
</script>

<style scoped lang="scss"></style>
